import * as swcHelpers from '@swc/helpers';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { mapServerToContactLensVariant } from '../variant-mappers/map-server-to-contact-lens-variant.js';
import { mapServerToProductBase } from './map-server-to-product-base.js';

var mapServerToContactLensProduct = (serverProduct, slug, locale, facetConfigList, priceSegmentChannelKey)=>{
    var ref;
    if ((serverProduct === null || serverProduct === void 0 ? void 0 : serverProduct.__typename) !== 'ContactLensProduct') {
        return {
            failure: 'incorrect-typename',
            message: `Expected ContactLensProduct for slug "${slug}", but got ${serverProduct === null || serverProduct === void 0 ? void 0 : serverProduct.__typename}`
        };
    }
    const variants = mapServerToContactLensVariant(serverProduct, slug, locale, priceSegmentChannelKey);
    if (!variants || variants.length === 0) {
        return {
            failure: 'no-variants',
            message: `Cannot return Contact Lens product with slug: "${slug}" because it has no variants`
        };
    }
    const _ref = mapServerToProductBase(serverProduct, variants, facetConfigList), { masterSku: defaultMasterSku  } = _ref, productbase = swcHelpers.objectWithoutProperties(_ref, [
        "masterSku"
    ]);
    const masterSku = ((ref = variants.find((variant)=>variant.isMasterProduct
    )) === null || ref === void 0 ? void 0 : ref.sku) || defaultMasterSku;
    return swcHelpers.objectSpread({}, productbase, {
        productType: 'Contact-lenses',
        variants,
        masterSku,
        isMasterProduct: serverProduct.productTypeDetails.isMaster,
        productMasterKey: serverProduct.productTypeDetails.productMasterKey
    });
};

export { mapServerToContactLensProduct };
//# sourceMappingURL=map-server-to-contact-lens-product.js.map
